(() => {
  if (window.KaguCartExperience) return;
  class KaguCartExperience {
    constructor() {
      this.busy = false;
      this.seelHydrating = false;
      this.recommendationProducts = new Map();
      this.bind();
      this.enhanceCartLayouts();
      this.hydrateSeelOptions();
      this.loadRecommendations();
    }
    shells() { return [...document.querySelectorAll('[data-kagu-cart-shell]')]; }
    bind() {
      document.addEventListener('click', (event) => {
        const close = event.target.closest('[data-cart-close]');
        if (close) return this.closeDrawer();
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) return this.changeLine(Number(remove.dataset.cartRemove), 0);
        const quantity = event.target.closest('[data-cart-quantity]');
        if (quantity) return this.changeLine(Number(quantity.dataset.cartQuantity), Math.max(0, Number(quantity.dataset.quantityValue)));
        const openRecommendation = event.target.closest('[data-recommendation-open]');
        if (openRecommendation) return this.openRecommendation(openRecommendation);
        const modalClose = event.target.closest('[data-product-modal-close]');
        if (modalClose) return this.closeProductModal();
        const modalAdd = event.target.closest('[data-product-modal-add]');
        if (modalAdd) return this.addModalSelection(modalAdd);
        const modalQuantity = event.target.closest('[data-product-modal-quantity]');
        if (modalQuantity) return this.changeModalQuantity(Number(modalQuantity.dataset.productModalQuantity));
        const previous = event.target.closest('[data-recommendation-prev]');
        const next = event.target.closest('[data-recommendation-next]');
        if (previous || next) this.scrollRecommendations(event.target.closest('.kagu-recommendations'), next ? 1 : -1);
      });
      document.addEventListener('change', (event) => {
        if (event.target.matches('[data-seel-toggle]')) return this.toggleSeel(event.target);
        if (event.target.matches('[data-cart-input]')) this.changeLine(Number(event.target.dataset.cartInput), Math.max(0, Number(event.target.value)));
        if (event.target.matches('[data-product-option]')) this.updateProductModal();
      });
      document.addEventListener('input', (event) => {
        if (!event.target.matches('[data-cart-note]')) return;
        clearTimeout(this.noteTimer);
        this.noteTimer = setTimeout(() => this.updateNote(event.target.value), 400);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const modal = document.querySelector('[data-kagu-product-modal][open]');
          if (modal) return this.closeProductModal();
          this.closeDrawer();
        }
      });
    }
    enhanceCartLayouts() {
      this.shells().forEach((shell) => {
        if (!shell.classList.contains('kagu-cart--page')) return;
        const note = shell.querySelector('.kagu-note');
        const main = shell.querySelector('.kagu-cart__main');
        if (!note || !main) return;
        note.open = true;
        note.classList.add('kagu-note--open');
        const summary = note.querySelector('summary');
        if (summary) summary.textContent = 'Special instructions for seller';
        const label = note.querySelector('label');
        if (label) label.remove();
        main.append(note);
      });
    }
    status(message) {
      this.shells().forEach((shell) => {
        const region = shell.querySelector('[data-cart-status]');
        if (region) region.textContent = message;
      });
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => this.shells().forEach((shell) => {
        const region = shell.querySelector('[data-cart-status]');
        if (region) region.textContent = '';
      }), 3500);
    }
    setBusy(value) {
      this.busy = value;
      this.shells().forEach((shell) => {
        shell.setAttribute('aria-busy', String(value));
        shell.querySelectorAll('button,input,textarea').forEach((control) => control.disabled = value);
      });
    }
    async changeLine(line, quantity) {
      if (this.busy) return;
      this.setBusy(true);
      try {
        await this.mutate('/cart/change.js', { line, quantity });
        this.status('Cart updated.');
      } catch (error) {
        this.status(error.message || 'Cart could not be updated. Please try again.');
        this.setBusy(false);
      }
    }
    async addRecommendation(variantId, quantity = 1) {
      if (this.busy) return;
      this.setBusy(true);
      try {
        await this.mutate('/cart/add.js', { items: [{ id: Number(variantId), quantity }] });
        this.status('Item added to your cart.');
      } catch (error) {
        this.status(error.message || 'Item could not be added.');
        this.setBusy(false);
      }
    }
    ensureProductModal() {
      let modal = document.querySelector('[data-kagu-product-modal]');
      if (modal) return modal;
      modal = document.createElement('dialog');
      modal.className = 'kagu-product-modal';
      modal.dataset.kaguProductModal = '';
      modal.innerHTML = '<button class="kagu-product-modal__close" type="button" data-product-modal-close aria-label="Close product options">&times;</button><div class="kagu-product-modal__grid"><div class="kagu-product-modal__media"><img data-product-modal-image alt=""></div><div class="kagu-product-modal__content"><p class="kagu-product-modal__eyebrow">Add to your workspace</p><h2 data-product-modal-title></h2><p class="kagu-product-modal__price" data-product-modal-price></p><p class="kagu-product-modal__sku" data-product-modal-sku></p><div class="kagu-product-modal__options" data-product-modal-options></div><div class="kagu-product-modal__footer"><div class="kagu-product-modal__quantity" aria-label="Quantity"><button type="button" data-product-modal-quantity="-1" aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" data-product-modal-quantity-input aria-label="Quantity"><button type="button" data-product-modal-quantity="1" aria-label="Increase quantity">+</button></div><button class="button" type="button" data-product-modal-add>Add to Cart</button></div><p class="kagu-product-modal__status" data-product-modal-status role="status" aria-live="polite"></p></div></div>';
      modal.addEventListener('click', (event) => { if (event.target === modal) this.closeProductModal(); });
      document.body.append(modal);
      return modal;
    }
    openRecommendation(button) {
      const product = this.recommendationProducts.get(button.dataset.productKey);
      if (!product) return this.status('Product options are temporarily unavailable.');
      const modal = this.ensureProductModal();
      modal.productData = product;
      modal.querySelector('[data-product-modal-title]').textContent = product.title;
      const options = modal.querySelector('[data-product-modal-options]');
      options.replaceChildren();
      (product.options || []).forEach((option, index) => {
        const optionName = typeof option === 'string' ? option : option.name;
        const wrapper = document.createElement('label');
        wrapper.className = 'kagu-product-modal__option';
        const label = document.createElement('span');
        label.textContent = optionName;
        const select = document.createElement('select');
        select.dataset.productOption = String(index);
        const optionValues = Array.isArray(option?.values) ? option.values : (product.variants || []).map((variant) => variant.options?.[index]);
        [...new Set(optionValues.filter(Boolean))].forEach((value) => {
          const choice = document.createElement('option');
          choice.value = value;
          choice.textContent = value;
          select.append(choice);
        });
        wrapper.append(label, select);
        options.append(wrapper);
      });
      const quantity = modal.querySelector('[data-product-modal-quantity-input]');
      quantity.value = 1;
      this.updateProductModal();
      modal.showModal();
    }
    selectedModalVariant() {
      const modal = document.querySelector('[data-kagu-product-modal]');
      const product = modal?.productData;
      if (!product) return null;
      const selected = [...modal.querySelectorAll('[data-product-option]')].map((select) => select.value);
      return (product.variants || []).find((variant) => selected.length ? selected.every((value, index) => variant.options?.[index] === value) : true) || null;
    }
    updateProductModal() {
      const modal = document.querySelector('[data-kagu-product-modal]');
      const product = modal?.productData;
      const variant = this.selectedModalVariant();
      if (!modal || !product) return;
      const image = modal.querySelector('[data-product-modal-image]');
      const source = variant?.featured_image?.src || variant?.featured_image || product.featured_image;
      if (source) image.src = source;
      image.alt = product.title;
      modal.querySelector('[data-product-modal-price]').textContent = variant ? this.money(variant.price) : '';
      modal.querySelector('[data-product-modal-sku]').textContent = variant?.sku ? 'SKU: ' + variant.sku : '';
      const add = modal.querySelector('[data-product-modal-add]');
      add.disabled = !variant?.available;
      add.textContent = variant?.available ? 'Add to Cart' : 'Unavailable';
      modal.querySelector('[data-product-modal-status]').textContent = variant?.available ? '' : 'This option is currently unavailable.';
    }
    changeModalQuantity(change) {
      const input = document.querySelector('[data-product-modal-quantity-input]');
      if (input) input.value = Math.max(1, Number(input.value || 1) + change);
    }
    async addModalSelection(button) {
      const variant = this.selectedModalVariant();
      const input = document.querySelector('[data-product-modal-quantity-input]');
      if (!variant?.available || this.busy) return;
      button.disabled = true;
      button.textContent = 'Adding…';
      await this.addRecommendation(variant.id, Math.max(1, Number(input?.value || 1)));
      this.closeProductModal();
    }
    closeProductModal() {
      const modal = document.querySelector('[data-kagu-product-modal]');
      if (modal?.open) modal.close();
    }
    getStoredSeel() {
      try { return JSON.parse(sessionStorage.getItem('kaguSeelProtection') || '{}'); }
      catch (error) { return {}; }
    }
    hydrateSeelOptions() {
      const stored = this.getStoredSeel();
      let needsProtection = false;
      document.querySelectorAll('[data-seel-option]').forEach((option) => {
        const present = option.dataset.seelPresent === 'true';
        if (present && option.dataset.seelVariantId) {
          sessionStorage.setItem('kaguSeelProtection', JSON.stringify({
            variantId: option.dataset.seelVariantId,
            price: option.dataset.seelPrice
          }));
        } else if (stored.variantId) {
          option.dataset.seelVariantId = stored.variantId;
          const price = option.querySelector('[data-seel-price-copy]');
          if (price && stored.price) price.textContent = 'for ' + stored.price;
        }
        const checkbox = option.querySelector('[data-seel-toggle]');
        if (checkbox) {
          checkbox.checked = present;
          checkbox.disabled = !present && !option.dataset.seelVariantId;
          if (!present && !option.dataset.seelVariantId) needsProtection = true;
        }
      });
      if (needsProtection && sessionStorage.getItem('kaguSeelOptOut') !== 'true') this.ensureSeelProtection();
    }
    isSeelItem(item) {
      const title = String(item.product_title || item.title || '').toLowerCase();
      const vendor = String(item.vendor || '').toLowerCase();
      return title.includes('worry-free') || title.includes('worry free') || vendor.includes('seel');
    }
    async ensureSeelProtection() {
      if (this.seelHydrating || this.busy) return;
      this.seelHydrating = true;
      try {
        const [cartResponse, productResponse] = await Promise.all([
          fetch('/cart.js', { headers: { Accept: 'application/json' } }),
          fetch('/products/worry-free-purchase.js', { headers: { Accept: 'application/json' } })
        ]);
        if (!cartResponse.ok || !productResponse.ok) throw new Error('Protection quote unavailable.');
        const cart = await cartResponse.json();
        if (!cart.items?.length || cart.items.some((item) => this.isSeelItem(item))) return;
        const merchandiseSubtotal = cart.items.reduce((total, item) => this.isSeelItem(item) ? total : total + item.final_line_price, 0);
        const targetQuote = merchandiseSubtotal * 0.0205;
        const product = await productResponse.json();
        const variants = (product.variants || []).filter((variant) => variant.available);
        const quote = variants.reduce((closest, variant) => {
          if (!closest) return variant;
          return Math.abs(variant.price - targetQuote) < Math.abs(closest.price - targetQuote) ? variant : closest;
        }, null);
        if (!quote) throw new Error('Protection quote unavailable.');
        sessionStorage.setItem('kaguSeelProtection', JSON.stringify({ variantId: String(quote.id), price: this.money(quote.price) }));
        await this.mutate('/cart/add.js', { items: [{ id: Number(quote.id), quantity: 1 }] });
        this.status('Worry-Free Delivery was added automatically. You can remove it anytime.');
      } catch (error) {
        document.querySelectorAll('[data-seel-option]').forEach((option) => {
          const checkbox = option.querySelector('[data-seel-toggle]');
          if (checkbox && option.dataset.seelPresent !== 'true') checkbox.disabled = true;
        });
        this.status(error.message || 'Worry-Free Delivery is temporarily unavailable.');
      } finally {
        this.seelHydrating = false;
      }
    }
    async toggleSeel(input) {
      if (this.busy) return;
      const option = input.closest('[data-seel-option]');
      if (!option) return;
      if (!input.checked) {
        const variantId = Number(option.dataset.seelVariantId);
        if (variantId) {
          sessionStorage.setItem('kaguSeelOptOut', 'true');
          this.setBusy(true);
          try {
            await this.mutate('/cart/update.js', { updates: { [variantId]: 0 } });
            this.status('Worry-Free Delivery removed.');
          } catch (error) {
            input.checked = true;
            this.status(error.message || 'Worry-Free Delivery could not be removed.');
            this.setBusy(false);
          }
        }
        return;
      }
      const variantId = Number(option.dataset.seelVariantId || this.getStoredSeel().variantId);
      if (!variantId) {
        input.checked = false;
        this.status('Worry-Free Delivery is temporarily unavailable. Please try again.');
        return;
      }
      this.setBusy(true);
      try {
        sessionStorage.removeItem('kaguSeelOptOut');
        await this.mutate('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
        this.status('Worry-Free Delivery added.');
      } catch (error) {
        input.checked = false;
        this.status(error.message || 'Worry-Free Delivery could not be added.');
        this.setBusy(false);
      }
    }
    async updateNote(note) {
      try {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note }) });
        this.status('Order note saved.');
      } catch (error) {
        this.status('Order note could not be saved.');
      }
    }
    async mutate(url, payload) {
      const ids = [...new Set(this.shells().map((shell) => shell.dataset.sectionId).filter(Boolean))];
      payload.sections = ids;
      payload.sections_url = window.location.pathname;
      const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || 'Cart request failed.');
      this.replaceSections(state.sections || {});
      this.updateBubble(state.item_count);
      this.setBusy(false);
      this.hydrateSeelOptions();
      this.loadRecommendations();
    }
    replaceSections(sections) {
      this.shells().forEach((shell) => {
        const html = sections[shell.dataset.sectionId];
        if (!html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.querySelector('[data-kagu-cart-shell="' + shell.dataset.kaguCartShell + '"]');
        if (replacement) shell.replaceWith(replacement);
      });
      this.enhanceCartLayouts();
    }
    updateBubble(count) {
      document.querySelectorAll('.cart-count-bubble span:first-child').forEach((element) => { element.textContent = count; });
    }
    closeDrawer() {
      document.querySelector('.cart-content')?.classList.remove('active');
      document.querySelector('.header__icons .overlay')?.classList.remove('overlay_active');
    }
    scrollRecommendations(section, direction) {
      const track = section?.querySelector('[data-recommendations-track]');
      if (track) track.scrollBy({ left: direction * track.clientWidth * 0.75, behavior: 'smooth' });
    }
    async loadRecommendations() {
      await Promise.all(this.shells().map(async (shell) => {
        const track = shell.querySelector('[data-recommendations-track]');
        const productId = shell.dataset.firstProductId;
        if (!track || !productId || track.dataset.loaded === productId) return;
        track.dataset.loaded = productId;
        try {
          let products = await this.fetchRecommendations(productId, 'complementary');
          if (!products.length) products = await this.fetchRecommendations(productId, 'related');
          track.replaceChildren(...products.slice(0, 4).map((product) => this.recommendationCard(product)));
          track.dataset.state = products.length ? 'ready' : 'empty';
          if (!products.length) track.textContent = 'More workspace ideas are coming soon.';
        } catch (error) {
          track.dataset.state = 'error';
          track.textContent = 'Recommendations are temporarily unavailable.';
        }
      }));
    }
    async fetchRecommendations(productId, intent) {
      const response = await fetch('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=4&intent=' + intent);
      if (!response.ok) return [];
      const data = await response.json();
      return data.products || [];
    }
    recommendationCard(product) {
      const productKey = String(product.id || product.handle || product.url);
      this.recommendationProducts.set(productKey, product);
      const card = document.createElement('article');
      card.className = 'kagu-rec';
      const link = document.createElement('a');
      link.className = 'kagu-rec__image';
      link.href = product.url;
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = product.title;
        image.loading = 'lazy';
        link.append(image);
      }
      const title = document.createElement('a');
      title.className = 'kagu-rec__title';
      title.href = product.url;
      title.textContent = product.title;
      const price = document.createElement('p');
      price.className = 'kagu-rec__price';
      price.textContent = this.money(product.price);
      const action = document.createElement('button');
      action.className = 'button button--secondary';
      action.type = 'button';
      action.dataset.recommendationOpen = '';
      action.dataset.productKey = productKey;
      action.textContent = 'Add to Cart';
      card.append(link, title, price, action);
      return card;
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    }
  }
  window.KaguCartExperience = new KaguCartExperience();
})();
